/*
 * Created by jmeo at 2021-05-13
 * FileName: index.ts
 */

export const isIOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.exec(navigator.userAgent) //navigator.userAgent.match()
export const isAndroid = false

export function isEmpty(val: any) {
  if (typeof val === 'number') return false
  else if (typeof val === 'boolean') return false
  else if (typeof val === 'string' && val.trim().length == 0) return true
  else if (Array.isArray(val) && val.length === 0) return true
  else if (!val) return true
}

export function getQueryParams(search?: string) {
  search = search || location.search
  const params: any = {}
  if (!isEmpty(search)) {
    search = search.replace(/\?/g, '')
    // search = decodeURIComponent(search)
    const searchArr = search.split('&')
    searchArr.forEach((item) => {
      const kv = item.split('=')
      if (!isEmpty(kv[1]) && kv[1] !== 'null')
        params[kv[0]] = decodeURIComponent(kv[1])
    })
  }
  return params
}

export function setTitle(title?: string | null) {
  document.title = title || ''
}

export function base64ToBlob(data: string, type: string) {
  // const arr = urlData.split(',');
  // const match = /:(.*?);/.exec(arr[0]) || []
  // const mime = match[1] || type;
  // 去掉url的头，并转化为byte
  const bytes = window.atob(data)
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length)
  // 生成视图（直接针对内存）：8位无符号整数，长度s1个字节
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob([ab], {
    type: type,
  })
}

export function getUrlParams(urlSearch: string) {
  const urlSearchParams = new URLSearchParams(urlSearch)
  return Object.fromEntries(urlSearchParams.entries())
}
